import { render } from "./MyPageTable.vue?vue&type=template&id=120dff7b&ts=true"
import script from "./MyPageTable.vue?vue&type=script&lang=ts"
export * from "./MyPageTable.vue?vue&type=script&lang=ts"

import "./MyPageTable.vue?vue&type=style&index=0&id=120dff7b&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/@quasar/app-webpack/lib/loaders/runtime.auto-import.js";
qInstall(script, 'components', {QTable,QCheckbox,QSelect,QBtn});
